import React from 'react';
import { getIn } from 'formik';
import RadioGroup from './radio/RadioGroup';
import FormInputFeedback from './feedback/FormInputFeedback';
import formPropTypes from '../prop-types/formPropTypes';

var FormRadioGroup = function FormRadioGroup(props) {
  var id = props.id,
      form = props.form,
      field = props.field,
      skin = props.skin,
      children = props.children;
  var error = getIn(form.errors, field.name);
  var isSubmitted = form.submitCount > 0;
  return /*#__PURE__*/React.createElement(RadioGroup, null, children, error && isSubmitted && /*#__PURE__*/React.createElement(FormInputFeedback, {
    feedbackType: "error",
    id: id,
    message: error,
    skin: skin
  }));
};

FormRadioGroup.defaultProps = {
  children: null,
  skin: 'dark'
};
export default FormRadioGroup;